import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import {
  ACCESSTOKEN,
  COMPANY_ID,
  USER_ID,
} from './../../../constants/local_storage'
import * as actions from './actions'

function* loadPermission(action) {
  const {
    data: {
      page,
      pageSize,
      searchName,
      companyID,
      filterObj,
      orderBy,
      orderType,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/permission`,
      // `http://booking-api/api/customer`,
      {
        searchName,
        page,
        pageSize,
        companyID,
        filterObj,
        orderBy,
        orderType,
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )

    yield put(actions.loadPermission.success(res.data, page))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadPermission.failure())
  }
}

function* loadPermissionDetail(action) {
  const {
    data: { id },
  } = action.payload
  // const company_id =
  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/permission/detail/${id}`,
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
    // cb(res.data[0]);
    // console.log(res.data.data);
    yield put(actions.loadPermissionDetail.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadPermissionDetail.failure())
  }
}

function* createPermission(action) {
  const { cb } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/permission/create`,
      {
        ...action.payload.data,
        created_by: USER_ID,
        action_log: { action_name: 'add', matching_name: 'permission' },
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
    cb(res.data)
    yield put(actions.createPermission.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.createPermission.failure())
  }
}

function* updatePermission(action) {
  const { cb } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/permission/update`,
      {
        ...action.payload.data,
        updated_by: USER_ID,
        action_log: { action_name: 'edit', matching_name: 'permission' },
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
    cb(res.data)

    yield put(actions.updatePermission.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.updatePermission.failure())
  }
}

function* loadPermissionMenuHierarchy(action) {
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/permission/master-menu-hierarchy`,
      {
        ...action.payload.data,
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )

    yield put(actions.loadPermissionMenuHierarchy.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadPermissionMenuHierarchy.failure())
  }
}

export default function* watchPermissionMasterDataState() {
  yield all([
    takeEvery(actions.CREATE_PERMISSION.REQUEST, createPermission),
    takeEvery(actions.LOAD_PERMISSION.REQUEST, loadPermission),
    takeEvery(actions.LOAD_PERMISSION_DETAIL.REQUEST, loadPermissionDetail),
    takeEvery(actions.UPDATE_PERMISSION.REQUEST, updatePermission),
    takeEvery(
      actions.LOAD_PERMISSION_MENU_HIERARCHY.REQUEST,
      loadPermissionMenuHierarchy,
    ),
  ])
}

export {
  createPermission,
  loadPermission,
  loadPermissionDetail,
  updatePermission,
  loadPermissionMenuHierarchy,
}
